import { Splide } from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.splide-video');
  const splides = [];

  for (let i = 0; i < carousels.length; i++) {
    const splide = new Splide(carousels[i], {
      // your options here
    });

    splide.mount({ Video });

    // store instance
    splides.push(splide);

    // listen for video play
    splide.on('video:play', () => {
      splides.forEach((other) => {
        if (other !== splide && other.Components.Video) {
          other.Components.Video.pause();
        }
      });
    });
  }
});